<astral-field-shell [control]="textControl" [forId]="inputId" [helpText]="helpText" [errorMessage]="errorMessage">
  <div class="translate-text-area">
    <textarea
      class="translate-text-area__control"
      [attr.id]="inputId"
      astralFieldAccessibility
      [astralFieldControl]="textControl"
      [astralFieldHelpText]="helpText"
      [astralFieldInputId]="inputId"
      [rows]="rows"
      [formControl]="textControl"
      [placeholder]="textControl.caption | translate"
      [required]="textControl.required ? true : null"
      [readonly]="textControl.isReadonly ? true : null"
      [ngClass]="{ locked: textControl.isReadonly }"
      (blur)="onblur()"
      (focus)="onfocus()"
    ></textarea>

    @if (showTranslate) {
      <button
        class="translate-text-area__translate-button"
        type="button"
        [attr.aria-label]="'TRANSLATE.TRANSLATE_BUTTON' | translate"
        [title]="'TRANSLATE.TRANSLATE_BUTTON' | translate"
        (click)="translateClicked()"
        >
        <i class="fa-light fa-language" aria-hidden="true"></i>
        <span class="screen-reader-only">{{ 'TRANSLATE.TRANSLATE_BUTTON' | translate }}</span>
      </button>
    }
  </div>
</astral-field-shell>
